<template>
    <CommonDialog v-show="show" :title="title" class="alert-dialog" @click="handleClose">
        <template v-slot:msg>
            <span class="dialog-message">{{ message }}</span>
        </template>
        <template v-slot:buttons>
            <div class="button-slot button-group">
                <div class="blue-btn btn-txt dialog-btn" @click="handleConfirm">{{ confirmTxt }}</div>
            </div>
        </template>
    </CommonDialog>
</template>

<script>
import CommonDialog from './Dialog.vue';
export default {
    name: "AlertDialog",
    data: function () {
        return {
            show: false,
            title: "提示",
            message: "確定要刪除嗎？",
            confirmTxt: "確定",
            confirmCallback: null,
        }
    },
    components: {
        CommonDialog
    },
    methods: {
        /**
         * 
         * @param {string} title 
         * @param {string} message 
         * @param {function} confirmCallback 
         * @param {string} confirmTxt 
         */
        showDialog(title, message, confirmCallback, confirmTxt = "確定") {
            this.title = title;
            this.message = message;
            this.confirmTxt = confirmTxt;
            // this.cancelTxt = cancelTxt;
            this.confirmCallback = confirmCallback;
            // this.cancelCallback = cancelCallback;
            this.show = true;
        },
        /**
        * 執行confirm callback
        */
        handleConfirm() {
            if (typeof this.confirmCallback == "function") {
                this.confirmCallback();
            }
        },
        handleClose() {
            this.show = false;
        }
    }
}
</script>
<style src="../../css/dialog_style.css">

</style>
<style scoped>
.button-slot {
    margin-bottom: 1rem;
}
</style>